import { render, staticRenderFns } from "./MatrizValoresSetting.vue?vue&type=template&id=e49496ce"
import script from "./MatrizValoresSetting.vue?vue&type=script&lang=js"
export * from "./MatrizValoresSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports